import type { ApolloClient } from "@apollo/client";
import { ACTIVE_CALL_TRANSCRIPT_STATUS_QUERY, type ActiveCallTranscriptStatusResponse } from "./queries";
import { clearActiveCallSelectionForCallSid } from "./sessionStorage";

export const clearWrapUpSessionIfCallFinalized = async (
  client: ApolloClient<object>,
  callSid: string
): Promise<boolean> => {
  const { data } = await client.query<ActiveCallTranscriptStatusResponse>({
    query: ACTIVE_CALL_TRANSCRIPT_STATUS_QUERY,
    variables: { callSid },
    fetchPolicy: "network-only"
  });

  if (!data?.twilioFlexCall?.interactionId) return false;

  clearActiveCallSelectionForCallSid(callSid);
  return true;
};
